import {} from '@mui/icons-material';
import { Box, Tooltip, Typography } from '@mui/material';

import { LUMIQ_ORGANIZATION_NAME } from '@/constants';
import { PinFilledIcon, PinOutlinedIcon } from '@/icons';
import { EVENTS, logEvent } from '@/services';
import { usePinLpMutation, useUnpinLpMutation } from '@/store';
import { LearningPathWithDuration, Referrer } from '@/types';

export const PinLpButton = ({
  learningPath,
  referrer,
}: {
  learningPath: LearningPathWithDuration;
  referrer?: Referrer;
}) => {
  const [pinLp] = usePinLpMutation();
  const [unpinLp] = useUnpinLpMutation();

  const isGlobalLp = learningPath.organizationName === LUMIQ_ORGANIZATION_NAME;
  const eventParams = {
    groupId: learningPath.groupId,
    location: referrer || '',
  };

  if (!isGlobalLp) {
    return (
      <Tooltip
        title={`Custom learning path created for ${learningPath.organizationName}`}>
        <Box
          sx={{
            bgcolor: theme => `${theme.palette.secondary.medium}80`,
            borderRadius: 3,
            px: 1,
            py: 0.5,
          }}>
          <Typography variant="caption1Bold" color="secondary.main">
            Custom
          </Typography>
        </Box>
      </Tooltip>
    );
  } else if (learningPath.isPinnedByOrg) {
    return (
      <Box
        onClick={e => {
          e?.preventDefault();
          e?.stopPropagation();
          unpinLp({ groupId: learningPath.groupId });
          logEvent(EVENTS.CONTENT_CURATION_EVENTS.LP_UNPIN, eventParams);
        }}
        sx={styles.pinButton}>
        <PinFilledIcon sx={{ fontSize: 14 }} />
        <Typography variant="caption1Bold">Pinned</Typography>
      </Box>
    );
  } else {
    return (
      <Box
        onClick={e => {
          e?.preventDefault();
          e?.stopPropagation();
          pinLp({ groupId: learningPath.groupId });
          logEvent(EVENTS.CONTENT_CURATION_EVENTS.LP_PIN, eventParams);
        }}
        sx={styles.pinButton}>
        <PinOutlinedIcon sx={{ fontSize: 14 }} />
        <Typography variant="caption1Bold">Pin</Typography>
      </Box>
    );
  }
};

const styles = {
  pinButton: {
    display: 'flex',
    gap: 0.5,
    py: 0.5,
    alignItems: 'center',
    color: 'secondary.main',
    transition: 'opacity 200ms ease',
    '&: hover': { opacity: 0.7 },
  },
};
